export interface ICertificationRequirementsSchema {
    signature: boolean;
    photo: boolean;
    orderPhoto: boolean;
    geocodeStops: boolean;
    restrictToHundredMeters: boolean;
    editClosedVisitStatus: boolean;
}
